// extracted by mini-css-extract-plugin
export var fullGrid = "_3d-3";
export var pdpPreviewContainer = "_3d-1";
export var previewContainer = "_3d-0";
export var togglePreviewContainer = "_3d-2";